import { useMindMapSelector } from './use-mind-map-selector';

export const useMindMapId = () => {
  return useMindMapSelector((state) => state.rootId);
};
